import axios from "axios";
import {api} from "../constants/api";
import {errors as E} from "../../../common/constants/errors";

export const closeInspection = (shumaID) => {
  const data = {
    shumaID: parseInt(shumaID, 10)
  };

  return axios.post(api.CLOSE_INSPECTION, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
    })
    .catch((err) => {
      console.error(`CLOSE_INSRECTION_ERROR: ${err}`)
    });
};
